export default {
  text: 'Nous préparons votre table 🍽…',
};
